import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "red"
}
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_5 = {
  key: 0,
  href: "/news/new",
  class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_7 = { class: "space-y-6" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "p-6" }
const _hoisted_11 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_12 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_13 = { class: "text-sm text-gray-600 mt-2" }
const _hoisted_14 = { class: "flex items-center gap-3 mt-2" }
const _hoisted_15 = { class: "text-xs text-gray-400" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6" }
const _hoisted_19 = { class: "text-lg font-bold text-gray-900 mb-2" }
const _hoisted_20 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_21 = { class: "flex justify-end gap-3" }
const _hoisted_22 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "news"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('news.title')), 1 /* TEXT */),
        ($props.userAdmin)
          ? (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString($setup.t('news.create')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      ($setup.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.t('news.no_news')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            onClick: $event => ($setup.goToNews($event, item)),
            class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition cursor-pointer"
          }, [
            (item.cover_image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.coverUrl(item),
                  class: "w-full"
                }, null, 8 /* PROPS */, _hoisted_9))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.title), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_12, _toDisplayString(item.user.name) + " · " + _toDisplayString($setup.formatDate(item.created_at)), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_13, _toDisplayString($setup.stripHtml(item.body).substring(0, 200)) + _toDisplayString($setup.stripHtml(item.body).length > 200 ? '...' : ''), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(item.comments_count) + " " + _toDisplayString($setup.t('news.comments')), 1 /* TEXT */),
                ($props.userAdmin)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("a", {
                        href: `/news/${item.id}/edit`,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        class: "text-xs text-blue-700 hover:underline"
                      }, _toDisplayString($setup.t('news.edit')), 9 /* TEXT, PROPS */, _hoisted_16),
                      _createElementVNode("button", {
                        onClick: _withModifiers($event => ($setup.confirmDelete(item)), ["stop"]),
                        class: "text-xs text-red-500 hover:underline"
                      }, _toDisplayString($setup.t('news.delete')), 9 /* TEXT, PROPS */, _hoisted_17)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ], 8 /* PROPS */, _hoisted_8))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createCommentVNode(" Delete Modal "),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeDeleteModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h2", _hoisted_19, _toDisplayString($setup.t('news.confirm_delete')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_20, _toDisplayString($setup.t('news.confirm_delete_message')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                onClick: $setup.closeDeleteModal,
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('news.cancel')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.deleteNews,
                disabled: $setup.submitting,
                class: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
              }, _toDisplayString($setup.submitting ? '...' : $setup.t('news.delete')), 9 /* TEXT, PROPS */, _hoisted_22)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}